import { render } from "./formmask.vue?vue&type=template&id=6b81b529"
import script from "./formmask.vue?vue&type=script&lang=js"
export * from "./formmask.vue?vue&type=script&lang=js"

import "./formmask.vue?vue&type=style&index=0&id=6b81b529&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__